export default {
  namespaced: true,
  state: {
    isFiliales: false,
    isMantenedorRegional: false,
    isModulos: false,
    isRoles: false,
    isSecciones: false,
  },
  mutations: {
    setIsFiliales(state, payload) {
      state.isFiliales = payload;
    },
    setIsMantenedorRegional(state, payload) {
      state.isMantenedorRegional = payload;
    },
    setIsModulos(state, payload) {
      state.isModulos = payload;
    },
    setIsRoles(state, payload) {
      state.isRoles = payload;
    },
    setIsSecciones(state, payload) {
      state.isSecciones = payload;
    },
  },
  actions: {
    AccionCambiarIsFiliales({ commit }, data) {
      commit("setIsFiliales", data);
    },
    AccionCambiarIsMantenedorRegional({ commit }, data) {
      commit("setIsMantenedorRegional", data);
    },
    AccionCambiarIsModulos({ commit }, data) {
      commit("setIsModulos", data);
    },
    AccionCambiarIsRoles({ commit }, data) {
      commit("setIsRoles", data);
    },
    AccionCambiarIsSecciones({ commit }, data) {
      commit("setIsSecciones", data);
    },
  },
};
